// @flow
import { memo } from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { isExternalUrl } from 'utils/url'

import css from './LicenseLink.sass'

type LicenseLinkProps = {
  ariaLabel?: string,
  withText?: boolean,
  withoutBorder?: boolean,
  className?: string,
  to?: string,
}

export const LicenseLink = memo<LicenseLinkProps>(function LicenseLink({
  ariaLabel,
  className,
  to = '/license',
  withoutBorder = false,
  withText = false,
}: LicenseLinkProps) {
  const isExternal = isExternalUrl(to)
  const Component = isExternal ? 'a' : Link
  const props = isExternal ? { href: to } : { to }

  return (
    // $FlowFixMe[prop-missing]
    <Component
      {...props}
      className={cx(css.root, className, withoutBorder && css.withoutBorder)}
      aria-label={ariaLabel}>
      <span className={css.img} />
      {withText && (
        <span className={css.text}>
          Государственная <br />
          лицензия
        </span>
      )}
    </Component>
  )
})
